<template>
  <component :is="currentLayout">
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
import { shallowRef, watch } from 'vue';
import { useRouter } from 'vue-router';

import BlankLayout from './blank/BlankLayout.vue';
import DesktopLayout from './desktop/DesktopLayout.vue';

const router = useRouter();

const currentLayout = shallowRef(DesktopLayout);

watch(
  () => router.currentRoute.value,
  (to) => {
    currentLayout.value = to.meta.layout ? BlankLayout : DesktopLayout;
  },
  { immediate: true },
);
</script>
